import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // ✅ নতুন import
import "../styles/Login.css";
import logo from "../assets/logo.png";

const isValidBDPhone = (phone) => {
  const patternWith88 = /^\+8801[3-9][0-9]{8}$/;
  const patternWithout88 = /^01[3-9][0-9]{8}$/;
  return patternWith88.test(phone) || patternWithout88.test(phone);
};

const Login = () => {
  const navigate = useNavigate();
  const { setIsLoggedIn } = useAuth(); // ✅ context থেকে setIsLoggedIn

  const [form, setForm] = useState({
    phone: "",
    password: "",
  });
  const [message, setMessage] = useState("");

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!isValidBDPhone(form.phone)) {
      setMessage("🚫 ভুল নাম্বার সঠিক ফোন নাম্বার দিন ");
      return;
    }

    if (!form.password) {
      setMessage("🚫 পাসওয়ার্ড দিন");
      return;
    }

    try {
      const res = await fetch("https://api.earnmoney0.top/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phone: form.phone,
          password: form.password,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        // যদি login fail হয়
        setMessage(data.message || "❌ ফোন নাম্বার বা পাসওয়ার্ড ভুল");
        return; // redirect হবে না
      }

      // Success হলে token save
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      setMessage("✅ লগইন সফল হয়েছে");
      setIsLoggedIn(true); // ✅ context update
      navigate("/dashboard"); // ✅ সরাসরি Dashboard এ নাও

    } catch (err) {
      console.error(err);
      setMessage("❌ সার্ভার এরর, পরে চেষ্টা করুন");
    }
  };

  return (
    <div className="register-wrapper">
      {/* LEFT SIDE */}
      <div className="register-left">
        <img src={logo} alt="Logo" className="logo" />
        <div className="login-texts">
          <p className="login-title">আপনার একাউন্ট লগইন করুন 🎉</p>
          <p className="info-subtext">
            যদি নতুন হয়ে থাকেন তাহলে নিচে{" "}
            <a href="/register">নতুন একাউন্ট খুলুন</a> এ চাপ দিন
          </p>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="register-right">
        <form className="register-form" onSubmit={handleSubmit}>
          {message && <p className="message">{message}</p>}

          <div className="form-group">
            <label>ফোন নাম্বার</label>
            <input
              type="text"
              name="phone"
              placeholder="আপনার ফোন নাম্বার লিখুন"
              value={form.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>পাসওয়ার্ড</label>
            <input
              type="password"
              name="password"
              placeholder="আপনার পাসওয়ার্ড লিখুন"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="submit-btn">
            লগইন করুন ✅
          </button>

          <button
            type="button"
            className="register-btn"
            onClick={() => navigate("/register")}
          >
            নতুন একাউন্ট খুলুন
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;